import clsx from 'clsx';
import { Icon, IconName } from './Icon';
import { FC, HTMLAttributes, ReactElement } from 'react';
import { ElementsButton } from './Button';

interface ErrorBannerProps {
  errorText: string;
  actionButton?: ReactElement<typeof ElementsButton>;
  icon?: IconName;
  className?: string;
  /**
   * Forwarded to the banner element. Deliberately no default: most callers today already wrap
   * the banner in their own alert container, and nesting two alerts double-announces the message.
   */
  role?: HTMLAttributes<HTMLDivElement>['role'];
  /** Pull the banner out to the page edge with negative horizontal margins. */
  bleed?: boolean;
}

export const ErrorBanner: FC<ErrorBannerProps> = ({
  errorText,
  actionButton,
  icon = 'warning',
  className,
  role,
  bleed = true,
}) => {
  return (
    <div
      role={role}
      className={clsx(
        'flex items-center bg-darkMode-danger/10 justify-between px-4 py-2',
        bleed && '-mx-6 sm:-mx-12',
        className
      )}
    >
      <div className={'flex gap-4'}>
        <Icon icon={icon} className={'text-darkMode-danger'} />
        <p className="text-darkMode-danger">{errorText}</p>
      </div>
      {actionButton}
    </div>
  );
};
